/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserTournament = {
    properties: {
        tournamentId: {
            type: 'number',
            isRequired: true,
        },
        role: {
            type: 'UserTournamentRole',
            isRequired: true,
        },
        teamId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
    },
} as const;
